import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
// Points to the root reference
import Loader from 'react-loader-spinner';
import { usePromiseTracker } from "react-promise-tracker";
import 'bootstrap/dist/css/bootstrap.css';

import './custom.scss'
import { blockStatement } from '@babel/types';
const LoadingIndicator = props => {
    const { promiseInProgress } = usePromiseTracker();
       return (
        promiseInProgress &&
        <div
      style={{
        width: "50%",
        height: "100px",
        justifyContent: "center",
       alignItems: "center",
       position: "absolute",
       left: "50vw",
       top: "50vh"
      }}
    >
      <Loader type="Circles" color="#422963" height="100%" width="100px" />
    </div>
      );  
 }
    


ReactDOM.render(<div><App />  <LoadingIndicator/></div>, document.getElementById('root'));
// const db = firebase.firestore();
// db.collection('Users')
// .add({ test:'hrllelee'})
// .then(() => {
// console.log("sucesss")
// },(err=>{
//     console.log("failed")
// }));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();




const rootElement = document.getElementById("root");
ReactDOM.render(<div><App />  <LoadingIndicator/></div>, rootElement);


